import React from 'react';
import { Card, Row, Col, Input, Select, DatePicker, Button, Checkbox } from 'antd';

const { Search } = Input;
const { Option } = Select;

interface StreamFiltersProps {
  searchText: string;
  statusFilter: string;
  outputTargetFilter: string;
  dateFilter: any;
  showArchived: boolean;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onOutputTargetChange: (value: string) => void;
  onDateChange: (value: any) => void;
  onShowArchivedChange: (value: boolean) => void;
  onRefresh: () => void;
}

const StreamFilters: React.FC<StreamFiltersProps> = ({
  searchText,
  statusFilter,
  outputTargetFilter,
  dateFilter,
  showArchived,
  onSearchChange,
  onStatusChange,
  onOutputTargetChange,
  onDateChange,
  onShowArchivedChange,
  onRefresh
}) => {
  return (
    <Card style={{ marginBottom: '16px' }}>
      <Row gutter={16}>
        <Col span={6}>
          <Search
            placeholder="Search streams..."
            value={searchText}
            onChange={(e) => onSearchChange(e.target.value)}
            allowClear
          />
        </Col>
        <Col span={4}>
          <Select
            placeholder="Filter by status"
            value={statusFilter}
            onChange={onStatusChange}
            style={{ width: '100%' }}
          >
            <Option value="all">All Statuses</Option>
            <Option value="draft">Draft</Option>
            <Option value="configured">Configured</Option>
            <Option value="live">Live</Option>
            <Option value="completed">Completed</Option>
            <Option value="cancelled">Cancelled</Option>
          </Select>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Filter by output"
            value={outputTargetFilter}
            onChange={onOutputTargetChange}
            style={{ width: '100%' }}
          >
            <Option value="all">All Outputs</Option>
            <Option value="youtube">YouTube (RTMP)</Option>
            <Option value="amagi_hls">Amagi (HLS)</Option>
          </Select>
        </Col>
        <Col span={4}>
          <DatePicker
            placeholder="Filter by date"
            value={dateFilter}
            onChange={onDateChange}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={3} style={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox checked={showArchived} onChange={(e) => onShowArchivedChange(e.target.checked)}>
            Show archived
          </Checkbox>
        </Col>
        <Col span={3}>
          <Button onClick={onRefresh} style={{ width: '100%' }}>
            Refresh
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default StreamFilters;
